import { AxiosRequestConfig } from "axios";
import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { BancoFormData } from "../schema/cadastro-bancario.schema";
import { toSlug } from "../../../shared/utils";

const criar = async (data: BancoFormData, config?: AxiosRequestConfig<any> | undefined): Promise<void> => {
    try {
        const response = await baseApiService.post('/bank-registration', data, config);
        return response.data.data.id;
    } catch (err) {
        throw errosHandler(err);
    }
};

const editar = async (id: string, data: BancoFormData): Promise<void> => {
    try {
        await baseApiService.put(`/bank-registration/${id}`, data);
    }
    catch (err) {
        throw errosHandler(err);
    }
};

const findAll = async (filtro?: string, pagina = 0, limite = 10, campo?: string): Promise<{ items: any[]; totalItems: number }> => {
    try {
        const filtroPesquisa = filtro?.trim() ? toSlug(filtro) : "";
        const query = filtroPesquisa
            ? `/bank-registration?page=${pagina + 1}&limit=${limite}&campo_pesquisa=bank.name&tipo_pesquisa=in&valor_pesquisa=${filtroPesquisa}`
            : `/bank-registration?page=${pagina + 1}&limit=${limite}`;
        const result = await baseApiService.get(query);
        const responseData = result.data?.data;
        return {
            items: Array.isArray(responseData?.items) ? responseData.items : [],
            totalItems: responseData?.meta?.totalItems || 0,
        };
    } catch (error) {
        console.error("Erro ao buscar empresas:", error);
        throw errosHandler(error);
    }
};

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/bank-registration/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const deletar = async (id: string): Promise<any> => {
    try {
        const result = await baseApiService.delete(`/bank-registration/${id}`);
        return result.data?.data;
    } catch (error) {
        console.error("Erro ao detalhar banco:", error);
        throw errosHandler(error);
    }
};

export const cadastroBancarioService = {
    criar,
    detalhar,
    findAll,
    deletar,
    editar,
};